export default "__VITE_ASSET__CnvXOKPa__"